module.exports = __webpack_public_path__ + "static/media/logoviacon_menuapp.59fcced7.svg";